import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_spooktacular: FaireCollectionEntity = {
  token: "col_spooktacular",
  type: "collection",
  name: "Spooktacular",
  description: "Fun and playful Halloween decor.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1604200213928-ba3cf4fc8436?w=400&h=400&fit=crop",
  season: "fall",
  itemCount: 27,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
